import { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { UserInfoTab, AccountInfoTab, DocumentsTab } from "./Components";
import { USER_TAB_KEYS, PROFILE_TABS, USERS_TAB } from "./constant";
import { MdEdit } from "react-icons/md";

const UserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useParams();

  const isViewMode = location.pathname.includes("view");
  const isProfilePage = location.pathname.startsWith("/profile");

  const TABS = isProfilePage ? PROFILE_TABS : USERS_TAB;
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const [isUserEditable, setIsUserEditable] = useState(false);
  const [isHRAdminEditable, setIsHRAdminEditable] = useState(false);
  const [isUserOnboarded, setIsUserOnboarded] = useState(false);
  const showEditButton = isUserOnboarded && !isViewMode;

  return (
    <div className="p-4 pt-2 md:pt-0">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3 mt-4 mb-2 md:mb-1">
          <button onClick={() => navigate(-1)} className="text-primary">
            <IoMdArrowRoundBack size={22} />
          </button>
          <h1 className="text-xl font-semibold text-primary">
            {isProfilePage ? "Profile" : isViewMode ? "View User" : "Edit User"}
          </h1>
        </div>
        {showEditButton  && (
          <button
            onClick={() => {
              isProfilePage
                ? setIsUserEditable(true)
                : setIsHRAdminEditable(true);
            }}
            className="text-white bg-primary flex rounded-md px-3 py-1 items-center gap-1"
          >
            <MdEdit size={22} />
            <span className="text-lg">Edit</span>
          </button>
        )}
      </div>

      <div className="mx-1 md:mx-3 border-b border-gray-200">
        <ul className="flex space-x-4 border-b flex-wrap -mb-px md:text-base text-sm font-medium text-center">
          {TABS.map((tab) => (
            <li className="me-2" key={tab.key}>
              <button
                className={`px-4 py-2 inline-block rounded-t-lg ${
                  activeTab === tab.key
                    ? "border-b-2 border-primary text-primary font-semibold"
                    : "text-gray-500 hover:text-primary"
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <AnimatePresence mode="wait">
          {activeTab === USER_TAB_KEYS.USER_INFO && (
            <motion.div
              key="user-info"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
            >
              <UserInfoTab
                userId={userId}
                isUserEditable={isUserEditable}
                setIsUserEditable={setIsUserEditable}
                isHRAdminEditable={isHRAdminEditable}
                setIsHRAdminEditable={setIsHRAdminEditable}
                setIsUserOnboarded={setIsUserOnboarded}
              />
            </motion.div>
          )}

          {!isProfilePage && activeTab === USER_TAB_KEYS.ACCOUNT_INFO && (
            <motion.div
              key="account-info"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
            >
              <AccountInfoTab
                userId={userId}
                isUserEditable={isUserEditable}
                setIsUserEditable={setIsUserEditable}
                isHRAdminEditable={isHRAdminEditable}
                setIsHRAdminEditable={setIsHRAdminEditable}
              />
            </motion.div>
          )}

          {activeTab === USER_TAB_KEYS.DOCUMENTS && (
            <motion.div
              key="documents"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
            >
              <DocumentsTab
                userId={userId}
                isUserEditable={isUserEditable}
                setIsUserEditable={setIsUserEditable}
                isHRAdminEditable={isHRAdminEditable}
                setIsHRAdminEditable={setIsHRAdminEditable}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default UserDetails;
